export default __webpack_public_path__ + "static/media/11-62.58893e65.jpeg";